<template>
    <div class="online">
        <div class="banner">
            <div class="banner-center center">
                <div class="banner-info">
                    <div class="btn shenqing bgRed" @click="openDialog('免费试用',0)">申请试用</div>
                </div>
            </div>
        </div>
        <div class="item_1">
            <div class="item-title">
                <h3 class="title1">为教培机构搭建远程教育平台</h3>
            </div>
            <div class="item-contents center">
                <ul class="nav-top">
                    <li v-for="(x,index) in item1_list" :class='{"actived": isHover == index}'  @mouseenter="hovernav(x,index)">
                        <img :src="'/static/img/product_online/chanpin6_0'+(index+1)+'.png'" alt="">
                        <div class="title">{{x.title}}</div>
                    </li>
                </ul>
                <div class="item-info clearfix">
                    <div class="info-left">{{itemsHover.left}}</div>
                    <div class="info-right">{{itemsHover.right}}</div>
                    <img :src="'/static/img/product_online/chanpin6_chahua_0'+(isHover+1)+'.png'" alt="">
                </div>
            </div>
        </div>
        <shen-qing></shen-qing>
    </div>
</template>

<script>
import shenQing from "./shenqing.vue";
export default {
    components: {
        shenQing,
    },
    data(){
        return{
            isHover:0,
            itemsHover:{
                    title: "课程线上化",
                        left:"老师上传课程，学员在线查看并学习",
                        right:"支持上传视频、图片、文字等多形式课程"
                },
            item1_list: [
                {
                    title: "课程线上化",
                        left:"老师上传课程，学员在线查看并学习",
                        right:"支持上传视频、图片、文字等多形式课程"
                },
                {
                    title: "课程体系化",
                        left:"老师根据教学内容上传课程内容，教学体系化",
                        right:"提高机构品牌形象"
                },
                {
                    title: "课程回顾",
                        left:"学员可反复回顾查看课程",
                        right:"提升学习效果"
                },
                {
                    title: "学习时间灵活",
                        left:"不固定学习时间",
                        right:"学员可根据自身时间灵活学习，更自由"
                },
                {
                    title: "作业互评",
                        left:"老师和家长可在线对作业进行点评互动",
                        right:"提高家长参与度"
                },
            ],
        }
    },
    created(){

    },
    mounted(){

    },
    methods:{
        hovernav(x, ind) {
            this.isHover = ind;
            this.itemsHover = {
                title: x.title,
                left:x.left,
                right:x.right,
            };
        },
        openDialog:function(title,type){//type:(0机构,1微官网)
            this.$parent.$refs.openPop.openDialog(title,type);
        }
    }
}
</script>

<style scoped lang="less">
.banner {
        width: 100%;
        height: 480px;
        margin-top: 80px;
        background: url("https://cdntest.yizhiniao.com/newWebsite_/product_online/chanpin6_banner.jpg") no-repeat center;

        .banner-center {
            height: 100%;
            position: relative;
        }

        .banner-info {
            position: absolute;
            bottom: 120px;
            left: 60px;
            text-align: left;
        }
    }
    .item_1{
        padding: 180px 0;
        .title2{
            margin-top: 25px;
            font-size: 22px;
            line-height:30px;

        }
        .item-contents{
            margin-top: 80px;

            ul.nav-top {
                display: flex;
                justify-content: space-between;
                padding: 0 150px;

                >li {
                    /* height: 118px; */

                    img {
                        width: 70px;
                        height: 70pxpx;
                        margin: 0 auto 12px;
                    }

                    .title {
                        text-align: center;
                        color:#4A4A4A;
                        font-size: 20px;
                        line-height: 28px;
                    }


                    &.actived {
                        .title {
                            position:relative;
                            color: #1E1E1E;
                            font-size: 22px;
                            line-height: 30px;
                            padding-bottom: 18px;
                            &:after{
                                content:"";
                                position: absolute;
                                bottom:0;
                                left: 0;
                                width: 100%;
                                height: 4px;
                                background: #1E1E1E;
                                border-radius: 4px;
                            }
                        }
                    }
                }
            }

            .item-info {
                width: 1000px;
                height:400px;
                margin:80px auto 0;
                position:relative;
                img{
                    width: 100%;
                    height:100%;
                    position: absolute;
                    top:0;
                    left:0;
                }
                .info-left{
                    float: left;
                    margin-top:100px;
                    margin-left:100px;
                }
                .info-right{
                    float: right;
                    margin-top:180px;
                    margin-left:193px;
                }
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/components/product_online.vue